import React from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Estilos de react-pdf-viewer
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface PDFViewerProps {
  pdfUrl: string;
  documentoNombre: string;
  onClose: () => void;
}

export const PDFViewer: React.FC<PDFViewerProps> = ({
  pdfUrl,
  documentoNombre,
  onClose
}) => {
  // Plugin con layout por defecto (incluye zoom, navegación, búsqueda, etc.)
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div className="flex flex-col h-full bg-white border-l">
      {/* Header con nombre del documento y botón de cerrar */}
      <div className="flex items-center justify-between p-3 border-b bg-gray-50">
        <h3 className="font-semibold text-sm truncate flex-1" title={documentoNombre}>
          {documentoNombre}
        </h3>
        <Button
          size="icon"
          variant="ghost"
          onClick={onClose}
          title="Cerrar visualizador"
          className="ml-2 flex-shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>

      {/* Visualizador de PDF con controles integrados */}
      <div className="flex-1 overflow-hidden">
        <Viewer
          fileUrl={pdfUrl}
          plugins={[defaultLayoutPluginInstance]}
        />
      </div>
    </div>
  );
};
